import React, { Component } from 'react'

import { withStyles } from '@material-ui/core/styles';
import View from 'react-flexbox'
import { Typography, Divider, Card, TextField, Select, MenuItem, InputLabel } from '@material-ui/core';


class ListaHistorico extends Component {
    constructor(props) {
        super(props)
        this.state = { uidUltimo: null, historicoArray: null, fieldExibir: "fluxoDev" }
    }


    componentWillReceiveProps(props) {
        if (props.uidObj && props.uidObj !== this.state.uidUltimo && props.customForm) {
            this.props.getHistorico(props.customForm, props.uidObj, (array) => {
                this.setState({ historicoArray: array })
            })
            this.setState({ uidUltimo: props.uidObj })
        }

    }
    renderItem(item, index, fieldHistorico) {

        const { classes, perfis } = this.props

        let nomeUsuario = "";

        if (perfis) {
            perfis.forEach(element => {
                if (element.uid === item.userLastChange) {
                    nomeUsuario = element.nome
                }
            });
        }


        return <Card key={index} className={classes.card}>
            <TextField
                // label={"Para:"}
                className={classes.cardContent}
                disabled
                multiline
                value={JSON.stringify(item.para[fieldHistorico]||"Sem Valor")}
                fullWidth
                InputProps={{
                    style: { color: "#000" }
                }}
            />

            <View style={{ paddingLeft: 5, paddingRight: 10 }}>
                <Typography variant="caption" className={classes.cardData}>{dateToString(item.data)}</Typography>
                <Typography variant="caption" className={classes.cardData}>{nomeUsuario || item.userLastChange}</Typography>
            </View>
        </Card >
    }

    calcTempo(usarArray, fieldExibir, dataInicio) {
        let mapTempo = {}

        // console.log('dataInicio', dataInicio);
        let hoje = new Date();
        // console.log('hoje', hoje);
        let dataAnterior = dataInicio;
        let ultimoChave=null;
        usarArray.forEach(item => {                    
            var hours = Math.abs(dataAnterior - new Date(item.data)) / 36e5;


            // let v = item.para[fieldExibir];
            let v = item.de[fieldExibir];
            if(!v){
                v=null;
            }

            ultimoChave= item.para[fieldExibir];

            let tempoAtual = mapTempo[v];
            if (!tempoAtual) {
                mapTempo[v] = hours
            } else {
                mapTempo[v] = tempoAtual + hours
            }
            dataAnterior = new Date(item.data)

        });

        var hours = Math.abs(dataAnterior - hoje) / 36e5;
        let tempoAtual = mapTempo[ultimoChave];
        if (!tempoAtual) {
            mapTempo[ultimoChave] = hours
        } else {
            mapTempo[ultimoChave] = tempoAtual + hours
        }   

        return mapTempo;

    }


    render() {
        const { historicoArray, fieldExibir } = this.state
        const { classes, fieldHistorico } = this.props




        if (historicoArray == null) {
            return "Sem Historico"
        }

        let dataInicio = null;
        historicoArray.sort((a, b) => (a.data > b.data) ? 1 : ((b.data > a.data) ? -1 : 0))
        let usarArray = historicoArray.filter(h => {
            if (!dataInicio) {
                dataInicio = new Date(h.data)
            }
            let b = h.para[fieldExibir]!==undefined;
            return b;
        }) || []


        let fPossiveis = fieldHistorico.split(",");
        let mapTempo = this.calcTempo(usarArray, fieldExibir, dataInicio)
        let comps = [];
        for (var key in mapTempo) {
            var val = mapTempo[key];
            comps.push(<Typography key={key} >{key?key==="null"?"Sem Valor":key:"Sem Valor"}: {val.toFixed(2)} Horas</Typography>)
        }
        return (
            <div>

                <View>
                    <Typography variant="h6" >Alterações em:</Typography>
                    <TextField
                        select
                        label="Selecione o Field"

                        value={fieldExibir}
                        onChange={(e) => this.setState({ fieldExibir: e.target.value })}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        fullWidth
                        margin="normal"
                    >
                        {fPossiveis.map(option => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </View>
                {usarArray[0] && <TextField
                    label={"Inicial"}
                    className={classes.cardContent}
                    disabled
                    multiline
                    value={usarArray[0].de[fieldExibir] ||"Sem valor inicial"}
                    fullWidth
                    InputProps={{
                        style: { color: "#000" }
                    }}
                />}

                {usarArray.map((item, index) => this.renderItem(item, index, fieldExibir))}

                <div>
                <View>
                    <Typography variant="h6" >Horas em: {fieldExibir}</Typography>

                </View>
                <div>
                    {comps}
                </div>

            </div>
            </div>
        )
    }
}

const styles = {
    card: {

        margin: 5,
        padding: 5
    },

    cardContent: {
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,

    },
    cardData: {
        paddingLeft: 5,


    },

};

export default withStyles(styles)(ListaHistorico);

export function dateToString(data) {

    if (!data) {
        return "";
    }
    if (typeof data === 'string') {
        data = new Date(data)
    }

    // try {
    //     data = data.toDate()
    // } catch (error) {
    //     try {
    //         data = new Date(data.seconds * 1000)
    //     } catch (error) {

    //     }
    // }


    try {


        var mm = data.getMonth() + 1; // getMonth() is zero-based
        var dd = data.getDate();
        var minutes = data.getMinutes();
        var hour = data.getHours();


        return hour + ":" + minutes + " " + [
            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            data.getFullYear(),
        ].join('/');
    } catch (error) {

        console.log('error', error);
        console.log('data', data);

        return "erro"

    }
}


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/HistoricoField/components/ListaHistorico/ListaHistorico.js